import { DomHelper } from "../general/utils";

export default class LanguageMenu {
  constructor () {
    let _scope = this;
    this.menus = document.getElementsByClassName('language-navigation');

    if(this.menus.length) {
      for(let menu of Array.from(this.menus)) {
        _scope.init(menu);
      }
    }
  }

  init (menu) {
    let header = menu.getElementsByClassName('dropdown-header')[0];

    if(DomHelper.elementExists(header)) {

      header.addEventListener('click', function () {
        if(menu.classList.contains('opened')) {
          menu.classList.remove('opened');

          window.removeEventListener('click', function(e){});
        } else {
          menu.classList.add('opened');

          window.addEventListener('click', function(e){
            if (!menu.contains(e.target)){
              menu.classList.remove('opened');
            }
          });
        }
      });
    }
  }
}